import type {V1GuideToWeb} from "@khanacademy/embedded-webapp-schema";
import {listenForSignal, sendSignal} from "@repo/integrations";

/**
 * Listen for the extension signal that the page context has changed.
 *
 * @param cb The callback to invoke when the signal is received.
 * @returns A function that can be used to unsubscribe from the signal.
 */
export function onUpdatePageContext(
    cb: (data: V1GuideToWeb.UpdatePageContext["data"]) => void,
): () => void {
    return listenForSignal<V1GuideToWeb.UpdatePageContext>(
        "guide:updatePageContext",
        cb,
    );
}

/**
 * Request the current page context from the extension. This will generally be
 * the first message that is sent when Khanmigo loads, but can be sent at any
 * time.
 */
export function requestContext() {
    sendSignal({
        type: "guide:requestContext",
    });
}

/**
 * Send the current botName and threadID to the extension.
 */
export function sendThreadInfo({
    threadID,
    botName,
}: {
    threadID?: string;
    botName?: string;
}) {
    sendSignal({
        type: "guide:sendThreadInfo",
        data: {
            botName,
            threadID,
        },
    });
}
